import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "mt-6" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "font-medium text-3xl leading-[48px] tracking-normal capitalize" }, "Organisation trained by details", -1)
const _hoisted_3 = { class: "flex flex-wrap mt-6 space-y-2 md:space-y-0 md:space-x-3 md:flex-nowrap" }
const _hoisted_4 = { class: "w-full md:w-1/2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  for: "firstname",
  class: "block mb-2 text-sm font-medium text-gray-900"
}, [
  /*#__PURE__*/_createTextVNode(" Name "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*")
], -1)
const _hoisted_6 = { class: "mt-6" }
const _hoisted_7 = { class: "flex flex-wrap mt-6 space-y-2 md:space-y-0 md:space-x-3 md:flex-nowrap" }
const _hoisted_8 = { class: "w-full md:w-1/2" }
const _hoisted_9 = { class: "block space-x-2" }
const _hoisted_10 = ["checked"]
const _hoisted_11 = {
  class: "inline-block pl-[0.15rem] capitalize",
  for: "checkboxDefault"
}
const _hoisted_12 = { class: "pb-16 mt-6" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h2", { class: "font-medium text-3xl leading-[48px] tracking-normal capitalize" }, "Contact Address", -1)
const _hoisted_14 = { class: "flex flex-wrap mt-6 space-y-2 md:space-y-0 md:space-x-3 md:flex-nowrap" }
const _hoisted_15 = { class: "w-full md:w-1/2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  for: "addressLine1",
  class: "block mb-2 text-sm font-medium text-gray-900"
}, "Address Line 1", -1)
const _hoisted_17 = { class: "w-full md:w-1/2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  for: "addressLine2",
  class: "block mb-2 text-sm font-medium text-gray-900"
}, "Address Line 2", -1)
const _hoisted_19 = { class: "flex flex-wrap mt-6 space-y-2 md:space-y-0 md:space-x-3 md:flex-nowrap" }
const _hoisted_20 = { class: "w-full md:w-1/2" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", {
  for: "city",
  class: "block mb-2 text-sm font-medium text-gray-900"
}, "City", -1)
const _hoisted_22 = { class: "w-full md:w-1/2" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", {
  for: "county",
  class: "block mb-2 text-sm font-medium text-gray-900"
}, "County / State", -1)
const _hoisted_24 = { class: "flex flex-wrap mt-6 space-y-2 md:space-y-0 md:space-x-3 md:flex-nowrap" }
const _hoisted_25 = { class: "w-full md:w-1/2" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", {
  for: "postcode",
  class: "block mb-2 text-sm font-medium text-gray-900"
}, "Postcode/ZIP", -1)
const _hoisted_27 = { class: "w-full md:w-1/2" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", {
  for: "country",
  class: "block mb-2 text-sm font-medium text-gray-900"
}, [
  /*#__PURE__*/_createTextVNode("Country "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*")
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("option", { selected: "" }, "Please select", -1)
const _hoisted_30 = ["value"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-6 bg-play-light-gray" }, null, -1)
const _hoisted_32 = { class: "mt-6" }

import { ref } from "vue";
import { useRouter } from "vue-router";

import DefaultButton from "@/components/DefaultButton.vue";

import api from "@/api/api";
import { useGlobalStore } from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewOrganisation',
  async setup(__props) {

let __temp: any, __restore: any

const globalStore = useGlobalStore();
const router = useRouter();

const countries = ((
  ([__temp,__restore] = _withAsyncContext(() => api.misc.listCountries())),
  __temp = await __temp,
  __restore(),
  __temp
)).countries;

const isSaving = ref(false);
const organisation = ref({
  name: "",
  address_line_one: "",
  address_line_two: "",
  city: "",
  country: "",
  county: "",
  postcode: "",
  play_included_organisation: false,
});

async function saveOrganisation() {
  try {
    isSaving.value = true;
    await api.organisations.createOrganisation(organisation.value);

    globalStore.toast("SUCCESS", "Organisation created");
    return router.push({ name: "Organisations" });
  } catch (error) {
    console.error(error);
  } finally {
    isSaving.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_TitleHeader = _resolveComponent("TitleHeader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_TitleHeader, {
        title: _ctx.$t('add-a-new-organisation')
      }, null, 8, ["title"])
    ]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "firstname",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((organisation.value.name) = $event)),
            class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
            placeholder: "",
            required: ""
          }, null, 512), [
            [_vModelText, organisation.value.name]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              class: "rounded hover:cursor-pointer",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((organisation.value.play_included_organisation) = $event)),
              checked: organisation.value.play_included_organisation
            }, null, 8, _hoisted_10), [
              [_vModelCheckbox, organisation.value.play_included_organisation]
            ]),
            _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('play-included-organisation')), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "addressLine1",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((organisation.value.address_line_one) = $event)),
            class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
            placeholder: "",
            required: ""
          }, null, 512), [
            [_vModelText, organisation.value.address_line_one]
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "addressLine2",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((organisation.value.address_line_two) = $event)),
            class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
            placeholder: "",
            required: ""
          }, null, 512), [
            [_vModelText, organisation.value.address_line_two]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "city",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((organisation.value.city) = $event)),
            class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
            placeholder: "city",
            required: ""
          }, null, 512), [
            [_vModelText, organisation.value.city]
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "county",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((organisation.value.county) = $event)),
            class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
            placeholder: "",
            required: ""
          }, null, 512), [
            [_vModelText, organisation.value.county]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "postcode",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((organisation.value.postcode) = $event)),
            class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
            placeholder: "",
            required: ""
          }, null, 512), [
            [_vModelText, organisation.value.postcode]
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _hoisted_28,
          _withDirectives(_createElementVNode("select", {
            id: "subscription",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((organisation.value.country) = $event)),
            class: "text-black border rounded w-full capitalize focus:outline-none focus:shadow-outline-purple font-normal transition duration-50 ease-in px-3 py-1.5 h-10 border-gray-600"
          }, [
            _hoisted_29,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(countries), (region) => {
              return (_openBlock(), _createElementBlock("option", {
                value: region.name,
                key: region.id,
                class: "capitalize"
              }, _toDisplayString(region.name), 9, _hoisted_30))
            }), 128))
          ], 512), [
            [_vModelSelect, organisation.value.country]
          ])
        ])
      ]),
      _hoisted_31,
      _createElementVNode("div", _hoisted_32, [
        _createVNode(DefaultButton, {
          onAction: saveOrganisation,
          type: "primary",
          loading: isSaving.value,
          disabled: false
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Save new Organisation ")
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ])
  ], 64))
}
}

})